import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { URL_CONST } from 'utils/urlConsts'

import { selectDeepfakeAlertTimestamp } from 'containers/Alerts/selectors'

import Button from 'components/lib/DesignSystem/V3/Button'

import DeepfakeAlertIcon from './DeepfakeAlertIcon'

const AlertBanner = styled.div`
  background: var(--color-surface);
  border-left: 4px solid var(--warning-color);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const AlertContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`

const AlertTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const AlertIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--warning-color);
`

const DeepfakeMeetingsAlert = () => {
  const alertTimestamp = useSelector(selectDeepfakeAlertTimestamp)

  if (!alertTimestamp) {
    return null
  }

  const getFilterUrl = () => {
    const urlParams = new URLSearchParams()
    urlParams.set('notification', 'suspicious')
    urlParams.set('timestamp', alertTimestamp)
    urlParams.set('statusFilter', 'suspicious')
    urlParams.set('liveOnly', 'true')
    return `${URL_CONST.deepfake.meetings}?${urlParams.toString()}`
  }

  return (
    <AlertBanner>
      <AlertContent>
        <AlertIcon>
          <DeepfakeAlertIcon width={24} height={24} />
        </AlertIcon>
        <AlertTextContainer>
          <div className="typography-subtitle-2">Live suspect detected</div>
          <div className="typography-body-1">
            A live meeting has been flagged as potentially suspicious
          </div>
        </AlertTextContainer>
        <Link
          to={getFilterUrl()}
          style={{
            textDecoration: 'none',
            color: 'inherit',
            marginLeft: '16px',
          }}
        >
          <Button id="deepfake-meetings-alert-button" variant="secondary" size="medium">
            Show suspicious meeting
          </Button>
        </Link>
      </AlertContent>
    </AlertBanner>
  )
}

export default DeepfakeMeetingsAlert
